import React, { Component } from 'react';
import Radium from 'radium';

const TOP_OFFSET = 20;

class TaskMenu extends Component {

	getContainerStyle() {
		var style = [this.localStyles().container];

		style.push({
			top: this.props.taskMenu.y + this.props.taskMenu.height + TOP_OFFSET,
			left: this.props.taskMenu.x
		})

		return style;
	}

	onOverlayClick() {
		this.props.onHide();
	}

	onContextMenu(evt) {
		evt.stopPropagation();
		evt.preventDefault();
		this.onOverlayClick();
	}

	render() {
		if (!this.props.taskMenu) {
			return null;
		}

		return (
			<div style={this.localStyles().fullScreenOverlay} onClick={(evt) => this.onOverlayClick(evt)} onContextMenu={(evt) => this.onContextMenu(evt)}>
				<div style={this.getContainerStyle()}>
					<div style={this.localStyles().menuItem}>Breakdown</div>
					<div style={this.localStyles().menuItem}>Move to tomorrow</div>
					<div style={this.localStyles().triangle}></div>
				</div>
				
			</div>
			
		);
	}

	localStyles() {
		return {
			fullScreenOverlay: {
				position: "fixed",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				opacity: 0,
				animation: 'all 0.1s ease-in-out 0.15s',
				animationFillMode: "forwards",
				animationName: bounce,
			},
			container: {
				position: "absolute",
				backgroundColor: this.props.style.colors.modalBackground,
				color: this.props.style.colors.black,
				paddingTop: 30,
				paddingBottom: 20,
				paddingLeft: 30,
				paddingRight: 40,
				borderRadius: 12,
				top: 30,
				left: 50,
				zIndex: 999
			},
			triangle: {
				position: "absolute",
				top: -10,
				left: 50,
				width: 0,
				height: 0,
				borderStyle: "solid",
				borderWidth: "0 10px 10px 10px",
				borderColor: `transparent transparent ${this.props.style.colors.modalBackground} transparent`
			},
			menuItem: {
				color: this.props.style.colors.white,
				marginBottom: 10,
				cursor: "pointer"
			}
		}
	}
}

const bounce = Radium.keyframes({
	"0%": {transform: "translateY(-20px)", opacity: 0},
	"50%": {transform: "translateY(-20px)", opacity: 0.4},
	"100%": {transform: "translateY(0)", opacity: 1},
}, 'fadeIn');

export default Radium(TaskMenu);


// WEBPACK FOOTER //
// ./src/components/TaskMenu.js